interface IconProps {
  className?: string;
}

export function CampaignCompletedIcon({ className = '' }: IconProps) {
  return (
    <svg 
      className={className}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M4 22V15" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      <rect x="8" y="6" width="4" height="3" fill="currentColor" opacity="0.3"/>
      <rect x="12" y="9" width="4" height="3" fill="currentColor" opacity="0.3"/>
      <rect x="8" y="12" width="4" height="3" fill="currentColor" opacity="0.3"/>
    </svg>
  );
}
